import { gql } from 'apollo-angular';

import { CATEGORY_FRAGMENT } from 'graphql/fragments/category';

export const ARTICLE_FRAGMENT = gql`
  fragment ArticleFragment on Article {
    id
    mnr
    ean
    name
    description
    category {
      ...CategoryFragment
    }
    width
    height
    depth
    milling
    unit
    listPrice
    purchasePrice
    direction
  }
  ${CATEGORY_FRAGMENT}
`;
